/**
 * External dependencies
 */
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import React, { useState } from 'react';

import { getPaymentMethodData } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { RawHTML } from '@wordpress/element';



/**
 * Internal dependencies
 */
import { swishPaymentCompleteHandler } from './swish-qr/checkout-subscriptions';
import SwishQRModal from './swish-qr/components/qrmodal/qrmodal';
import './swish-qr/components/qrmodal/qrmodal.scss';


const settings = getPaymentMethodData( 'redlight_swish-ecommerce', {} );
const defaultLabel = __( 'Swish', 'woocommerce-gateway-swish-ecommerce' );
const label = decodeEntities( settings?.title || '' ) || defaultLabel;

const LabelComponent = () => {

    return (
        <div>
            <img
                src={ settings.icon }
                alt={ label }
            />
        </div>
    );
};
const ContentComponent = ({
	billing,
	eventRegistration,
	emitResponse,
	components,
} ) => {
    const {onCheckoutSuccess} = eventRegistration;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [qrCodeData, setQrCodeData] = useState(null);
    const [swishToken, setSwishToken] = useState(null);

    const paymentProcessing = swishPaymentCompleteHandler(
        onCheckoutSuccess,
        setIsModalOpen,
        setQrCodeData,
        setSwishToken,
        emitResponse
    )

    return (
        <>
            <RawHTML>
                {  settings.description || '' }
            </RawHTML>
            <SwishQRModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
                qrCodeData={qrCodeData} 
                swishToken={swishToken} 
                billing={billing} 
            />
        </>

    );
};

const canMakePayment = (billing) => {
    return billing.cartTotals.currency_code == 'SEK';
};

const swishPaymentMethod = {
    name: 'redlight_swish-ecommerce',
    label: <LabelComponent />,
    ariaLabel: __('Swish Ecommerce payment method', 'woocommerce-gateway-swish-ecommerce'),
    content: <ContentComponent />,
    edit: <ContentComponent />,
    canMakePayment,
};

registerPaymentMethod(swishPaymentMethod);